/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function CredentialsController(credentialsService, $scope, $mdDialog, types, entityId, isReadOnly) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;

        vm.isReadOnly = isReadOnly;

        vm.cancel = cancel;
        vm.save = save;
        vm.clear = clear;

        loadCredentials();
    };

    function loadCredentials() {
        credentialsService.getCredentials(entityId.entityType, entityId.id).then(function success(credentials) {
            vm.credentials = credentials;
        });
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function clear() {
        vm.credentials.keyId = null;
        vm.credentials.keyValue = null;
    }

    function save() {
        credentialsService.saveCredentials(vm.credentials).then(function success(credentials) {
            vm.credentials = credentials;
            $scope.theForm.$setPristine()
            $mdDialog.hide();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/dialog/credentials.controller.js